import React from 'react';
import cx from 'classnames';
import { monthlyOrderStatuses } from '../../../interfaces';
import { lightText } from '../../../instruments';
import Styles from '../m_styles.less';

type IShowStatus = {
    status?: monthlyOrderStatuses;
    search?: string;
};
export const ShowStatus: React.FC<IShowStatus> = ({ status, search }: IShowStatus) => {
    const testStatus = status ? lightText(status.toUpperCase(), search) : '';
    if (!status) {
        return null;
    } else
        switch (status) {
            case monthlyOrderStatuses.APPROVED:
            case monthlyOrderStatuses.CANCELLED:
            case monthlyOrderStatuses.PAID:
            case monthlyOrderStatuses.DRAFT:
                return (
                    <span className={Styles.monthlyOrderStatus}>
                        <span
                            className={cx({
                                [Styles.approved]: status === monthlyOrderStatuses.APPROVED,
                                [Styles.cancelled]: status === monthlyOrderStatuses.CANCELLED,
                                [Styles.paid]: status === monthlyOrderStatuses.PAID,
                                [Styles.draft]: status === monthlyOrderStatuses.DRAFT,
                            })}
                        >
                            {testStatus}
                        </span>
                    </span>
                );
            default:
                return <span className={Styles.monthlyOrderStatus}>{testStatus}</span>;
        }
};
